import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import config from '../config/index';

const API_URL = `https://${config.server.url}:${config.server.port}`;
const axiosDefault = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

Vue.use(VueAxios, axiosDefault);

export default axiosDefault;
